<!-- eslint-disable vue/no-v-html -->
<template>
  <transition name="slide-left">
    <div
      class="Toast fixed right-0 z-50 py-2 rounded-l-lg text-white"
      :class="[
        toast.legacyState.type === 'normal' && 'bg-green-emerald',
        toast.legacyState.type === 'warning' && 'bg-ochre',
        toast.legacyState.type === 'error' && 'bg-terracotta',
      ]"
      v-if="toast.legacyState.active"
    >
      <div class="flex flex-row px-4 items-center">
        <div
          v-html="toast.legacyState.text"
          class="flex-1 text-center mr-4"
          :class="toast.legacyState.onClick && 'cursor-pointer'"
          @click="toast.legacyState.onClick && toast.legacyState.onClick()"
        />
        <CoreIcon
          class="cursor-pointer"
          icon-id="x"
          size="xs"
          @click="toast.close"
        />
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { useToast } from '.'

const toast = useToast()
</script>

<style lang="scss" scoped>
@import '../../styles/lib';

.Toast {
  top: 32px;
  max-width: 70vw;
  will-change: transform, opacity;

  @include size-above(md) {
    max-width: 40vw;
  }
}

.slide-left {
  &-enter-active,
  &-leave-active {
    transition: transform 100ms ease-in-out;
  }
  &-enter-from,
  &-leave-to {
    transform: translateX(120%);
  }
}
</style>
